<div class="icon-container" [style.height.px]="height()">
  <img [src]="`assets/img/lsap-icons/${name()}.${type()}`" alt="icon" class="icon">
</div>

